import { merge } from 'lodash';

import { UPDATE_SETTINGS, UPDATE_ALL_SETTINGS } from 'constants/internal';

const defaultState = {
  enablePopup: false,
  maintainance: false,
  enableTracking: false,
};

export default function settings(state, action) {
  const newState = state || defaultState;
  const { type, payload } = action;

  switch (type) {
    case UPDATE_SETTINGS:
      return { ...newState, [payload.label]: payload.value };
    case UPDATE_ALL_SETTINGS:
      return merge(newState, payload);
    default:
      return newState;
  }
}
